import { stripMarkdownLinkFormatting } from '#pplx/frontend/common/markdownTitle.js';
var CollectionUserPermission;
(function (CollectionUserPermission) {
    CollectionUserPermission[CollectionUserPermission["NONE"] = 0] = "NONE";
    CollectionUserPermission[CollectionUserPermission["READER"] = 1] = "READER";
    CollectionUserPermission[CollectionUserPermission["WRITER"] = 2] = "WRITER";
    CollectionUserPermission[CollectionUserPermission["EDITOR"] = 5] = "EDITOR";
    CollectionUserPermission[CollectionUserPermission["OWNER"] = 4] = "OWNER";
    CollectionUserPermission[CollectionUserPermission["OWNER_DEFAULT_BOOKMARKS"] = 6] = "OWNER_DEFAULT_BOOKMARKS";
    CollectionUserPermission[CollectionUserPermission["INVITED_READER"] = 11] = "INVITED_READER";
    CollectionUserPermission[CollectionUserPermission["INVITED_WRITER"] = 12] = "INVITED_WRITER";
})(CollectionUserPermission || (CollectionUserPermission = {}));
function atLeastWriter(permission) {
    return (permission >= CollectionUserPermission.WRITER &&
        permission < CollectionUserPermission.INVITED_READER);
}
function getActiveComputerHarnessMode(modeConfig) {
    if (!modeConfig)
        return undefined;
    if (modeConfig.harness_mode !== undefined) {
        return { version: modeConfig.version, harness_mode: modeConfig.harness_mode };
    }
    return {
        version: modeConfig.version,
        model_preference: modeConfig.orchestrator_model,
        reasoning_effort: modeConfig.orchestrator_effort,
    };
}
export const CLIENT_SEARCH_PLACEHOLDER = 'CLIENT_SEARCH_PLACEHOLDER';
export const createPlaceholderResult = ({ rawQuery, fork, existingEntryUUID, existingUuid, collection, isRelatedQuery, newFrontendContextUUID, existingFrontendContextUUID, submitFromArticleOverride, isNavSuggestionsDisabled, isCopilot, queryMode, newAttachments, parentContextUUID, isPersonalized, forceNew, finalSources, uuid, threadMetadataTitle, threadMetadataThreadUrlSlug, threadMetadataMode, modelPreferenceSubmit, modeConfig, querySource, queryDisplayMetadata, proactive_upgrade_reason, targetThreadAccessLevelOverride, }) => {
    const query = rawQuery.trim();
    const initialText = (() => {
        if (isCopilot) {
            return JSON.stringify([
                {
                    step_type: 'INITIAL_QUERY',
                    content: { query: '' },
                    uuid: '',
                },
            ]);
        }
        else if (newAttachments.length > 0) {
            return JSON.stringify({
                web_results: newAttachments.map((attachment) => ({
                    url: attachment,
                    is_attachment: true,
                })),
            });
        }
        else {
            return null;
        }
    })();
    const parentInfo = fork
        ? {
            title: submitFromArticleOverride?.article_info?.title ?? threadMetadataTitle,
            url_slug: (submitFromArticleOverride && 'thread_url_slug' in submitFromArticleOverride
                ? submitFromArticleOverride.thread_url_slug
                : undefined) ?? threadMetadataThreadUrlSlug,
            mode: ((submitFromArticleOverride && 'mode' in submitFromArticleOverride
                ? submitFromArticleOverride.mode
                : undefined) ?? threadMetadataMode)?.toUpperCase(),
        }
        : undefined;
    const shouldAttachCollectionInfo = collection &&
        (targetThreadAccessLevelOverride != null ||
            (collection.user_permission != null && atLeastWriter(collection.user_permission)));
    const collectionSchematized = shouldAttachCollectionInfo
        ? {
            ...collection,
            slug: collection.slug ?? undefined,
            title: collection.title ?? undefined,
            emoji: collection.emoji ?? undefined,
            appearance: collection.appearance
                ? {
                    icon: collection.appearance.icon ?? undefined,
                    color: collection.appearance.color ?? undefined,
                    emoji: collection.appearance.emoji ?? undefined,
                }
                : undefined,
        }
        : undefined;
    return {
        parent_info: undefined,
        plan: undefined,
        summary: undefined,
        form: undefined,
        status: 'PENDING',
        reconnectable: true,
        final: false,
        query_str: query,
        // New turns need their timestamp before the first server message arrives.
        ...(!existingEntryUUID && { entry_created_datetime: new Date().toISOString() }),
        thread_title: stripMarkdownLinkFormatting(query),
        query_source: querySource,
        // backend_uuid and context_uuid required by the backend
        backend_uuid: forceNew ? '' : (existingEntryUUID ?? ''),
        bookmark_state: collection ? 'BOOKMARKED' : 'NOT_BOOKMARKED',
        context_uuid: parentContextUUID ?? '',
        // existingFrontendContextUUID is passed when we re-write existing thread entry
        frontend_context_uuid: existingFrontendContextUUID ?? newFrontendContextUUID ?? '',
        uuid: existingUuid ?? uuid,
        frontend_uuid: existingUuid ?? uuid,
        ...(fork
            ? {
                parent_info: parentInfo,
            }
            : {}),
        author_username: undefined,
        author_image: undefined,
        // Note: The BE uses the length of the sources array to determine writing vs internet
        // Remove after we refactor the BE to remove search focus
        search_focus: finalSources.length === 0 ? 'writing' : 'internet',
        sources: { sources: finalSources },
        num_sources_display: undefined,
        personalized: isPersonalized,
        attachments: newAttachments,
        blocks: [],
        social_info: {
            like_count: 0,
            fork_count: 0,
            user_likes: false,
        },
        mode: queryMode
            ? queryMode.toUpperCase()
            : isCopilot
                ? 'COPILOT'
                : 'CONCISE',
        text: initialText ?? undefined,
        collection_info: collectionSchematized,
        is_related_query_result: isRelatedQuery ?? false,
        related_queries: [],
        media_items: [],
        widget_data: [],
        widget_intents: [],
        knowledge_cards: [],
        related_query_items: [],
        sources_list: [],
        answer_modes: [],
        // @ts-expect-error is_nav_suggestions_disabled is not typed
        // TODO: fix this
        is_nav_suggestions_disabled: isNavSuggestionsDisabled,
        structured_answer_block_usages: [],
        display_model: modelPreferenceSubmit,
        model_preference: modelPreferenceSubmit,
        active_computer_harness_mode: getActiveComputerHarnessMode(modeConfig),
        query_display_metadata: queryDisplayMetadata,
        search_mode: queryMode === 'asi' ? 'ASI' : undefined,
        proactive_upgrade_reason,
    };
};
//# sourceMappingURL=createPlaceholderResults.js.map